module.exports = __webpack_public_path__ + "static/media/preloader-Big-HIPPO-withText-combined.ce10bc07.gif";